import React from 'react';
import './App.css';
import AdSense from 'react-adsense';
import ImageUploadButton from './components/ImageUploadButton'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppBar,Toolbar } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
});

const styles = theme => ({
  card: {
    maxWidth: 400,
  },
  mainGrid: {
    maxWidth: 1200,
    padding: theme.spacing.unit * 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    margin: theme.spacing.unit,
  }
});

function App(props) {
  const { classes } = props;
  return (
    <MuiThemeProvider theme={theme}>
      <div className="App">
        <AppBar position="static" color="primary">
          <Toolbar>
            Faviconジェネレーター
          </Toolbar>
        </AppBar>
        {/* <Button variant="contained" color="primary" className={classes.button}>
          ダウンロード
          <CloudUploadIcon className={classes.rightIcon}/>
        </Button> */}
      </div>
      <Grid container className={classes.mainGrid}>
        <Grid item xs={12}>
          <div>
            <h2>Favicon ジェネレーターについて</h2>
            <p>
              Faviconジェネレーターは、ブラウザ上で、JPEG, PNG, GIF などの画像ファイルから favicon 用の画像(favicon.ico)を生成・変換するサービスです。
            </p>
            <p>
              下記の特徴を備えています。
            </p>
            <ul>
              <li>ネットワーク上に画像をアップロードする必要がなく、全てローカル上で完結するため、セキュリティ的にも安全です。</li>
              <li>アップロードがないため、高速な変換を可能としています。</li>
              <li>マルチアイコンに対応</li>
              <li>用途によって、様々なファイルサイズに変換が可能</li>
              <li>透過に対応</li>
            </ul>
            <div>
              <AdSense.Google 
                client='ca-pub-9501702553332066'
                slot='3356788989'
                style={{ display: "block" }} 
                format="auto" />
            </div>
          </div>
        </Grid>

        <Grid item xs={12}>
          <h2>画像をFaviconに変換する</h2>
          <ImageUploadButton/>
        </Grid>

        <Grid item xs={12}>
          <div>
            <h2>使い方</h2>
            <ol>
              <li>変換する画像を選択</li>
              <li>サイズの選択</li>
              <li>「画像を変換する」をクリック</li>
              <li>「ダウンロード」をクリック</li>
            </ol>
            <p>上記のステップを踏むだけで簡単に変換ができます。</p>
            <p>
              変換までの動画(デモ)を撮りましたので参考にしてください。
              <CardMedia component="img" image="/favicon_generator_demo.gif" className={classes.card} />
            </p>
            <p>
              Favicon の画像形式は 「.ico」という拡張子で扱われ、一般的には「favicon.ico」というファイルを作って利用することが多いです。
              Favicon ジェネレータでもダウンロードする際に「favicon.ico」というファイル名でダウンロードされます。
            </p>
            <div>
              <AdSense.Google 
                client='ca-pub-9501702553332066'
                slot='3356788989'
                style={{ display: "block" }} 
                format="auto" />
            </div>
          </div>
        </Grid>
 
        <Grid item xs={12}>
          <div>
            <h2>Favicon (ファビコン) とは</h2>
            <p>
              Favicon (ファビコン)とは下記の画像のように、ブラウザのタブに表示される、小さいアイコン画像のことを指します。
              また、ブックマークをしたときなども、faviconの画像が表示されます。
              <CardMedia component="img" image="/tab_img.png" className={classes.card} />
            </p>
            <p>
              Favicon の画像形式は 「.ico」という拡張子で扱われ、一般的には「favicon.ico」というファイルを作って利用することが多いです。
              Favicon ジェネレータでもダウンロードする際に「favicon.ico」というファイル名でダウンロードされます。
            </p>
            <div>
              <AdSense.Google 
                client='ca-pub-9501702553332066'
                slot='3356788989'
                style={{ display: "block" }} 
                format="auto" />
            </div>
          </div>
        </Grid>
     {/* End footer */}
      </Grid>
      {/* Footer */}
    <footer className="App-footer">
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
          プライバシーポリシー
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Typography variant="subtitle1" color="textSecondary" component="p">
              当サイトが使用しているアクセス解析ツールについて
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              当サイトが使用しているアクセス解析ツールについて
              当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。
              このGoogleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。
              このトラフィックデータは匿名で収集されており、個人を特定するものではありません。
              この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
              この規約に関して、詳しくは<a href="https://www.google.com/analytics/terms/jp.html" target="_blank">こちら</a>、または <a href="https://policies.google.com/technologies/partner-sites?hl=ja" target="_blank">こちら</a>をクリックしてください。
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Typography variant="subtitle1" color="textSecondary" component="p">
              免責事項
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              当サイトからリンクやバナーなどによって他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。
              当サイトに掲載されている内容については、必ずしもその正確性、信頼性について保証するものではありません。
              当サイトに掲載された内容、及びサービス利用によって生じた損害等の一切の責任を負いかねますのでご了承ください。
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </footer>
 
    </MuiThemeProvider>
  );
}

export default withStyles(styles)(App);
